import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Pagination from "../layout/Pagination";
import TruncatedTd from "../layout/TruncatedTd";
import PermissionGate from "../layout/PermissionGate";

const AllDelivaryCompanies = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [company, setCompany] = useState({});
  const [popup, setPopup] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchDelivaryCompanies = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}all-delivary-companies?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
          setSelectedCompanies([]);
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const toggleSelectCompany = (companyId) => {
    setSelectedCompanies((prev) =>
      prev.includes(companyId)
        ? prev.filter((id) => id !== companyId)
        : [...prev, companyId]
    );
  };
  const toggleSelectAllCompanies = () => {
    if (selectedCompanies.length === data.length) {
      setSelectedCompanies([]);
    } else {
      setSelectedCompanies(data.map((item) => item._id));
    }
  };
  const changeRingPriorityBatch = (excludeFromRingPriority) => {
    if (selectedCompanies.length === 0) return;
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}change-delivary-company-ring-priority-batch`,
        {
          ids: selectedCompanies,
          excludeFromRingPriority: excludeFromRingPriority,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setPopup("");
          setSelectedCompanies([]);
          fetchDelivaryCompanies();
        }
      })
      .catch(console.error);
  };
  const openPopup = (action, data) => {
    setCompany(data);
    setPopup(action);
  };
  const changeStatus = () => {
    if (company.id !== undefined && company.status !== undefined) {
      const status = company.status === true ? false : true;
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}change-delivary-company-status`,
          {
            id: company.id,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setCompany({});
            fetchDelivaryCompanies();
          }
        })
        .catch(console.error);
    }
  };
  const deleteDelivaryCompany = () => {
    if (company._id !== undefined) {
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}delete-delivary-company`,
          {
            _id: company._id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setCompany({});
            fetchDelivaryCompanies();
          }
        })
        .catch(console.error);
    }
  };
  useEffect(() => {
    fetchDelivaryCompanies();
  }, [page, search]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Delivery Company List
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <PermissionGate required={`view_delivery_company_list`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Search*/}
                      <div className="w-100 my-1">
                        <input
                          type="text"
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          id="searchInput"
                          className="form-control w-100"
                          placeholder="Search Companies ..."
                          autoComplete="off"
                        />
                      </div>
                      {/*end::Search*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div
                      className="card-body py-4 text-center"
                      id="filterDataWrap"
                    >
                      {/*begin::Table*/}
                      {/*begin::Ring Priority Batch Bar*/}
                      <PermissionGate
                        required={`edit_delivery_company_ring_priority`}
                        fallback={<></>}
                      >
                        {selectedCompanies.length > 0 && (
                          <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-md-between gap-2 bg-light-warning rounded p-3 mb-4">
                            <span className="fw-bold">
                              {selectedCompanies.length} Compan
                              {selectedCompanies.length === 1 ? "y" : "ies"}{" "}
                              Selected
                            </span>
                            <div className="d-flex flex-wrap gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setPopup("batch-exclude");
                                }}
                              >
                                Exclude From Ring Priority
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  setPopup("batch-include");
                                }}
                              >
                                Include In Ring Priority
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-light"
                                onClick={() => {
                                  setSelectedCompanies([]);
                                }}
                              >
                                Clear Selection
                              </button>
                            </div>
                          </div>
                        )}
                      </PermissionGate>
                      {/*end::Ring Priority Batch Bar*/}

                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="table align-middle table-row-dashed fs-6 gy-5">
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <PermissionGate
                                  required={`edit_delivery_company_ring_priority`}
                                  fallback={<></>}
                                >
                                  <th className="text-center min-w-50px">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={
                                        data.length > 0 &&
                                        selectedCompanies.length ===
                                        data.length
                                      }
                                      onChange={toggleSelectAllCompanies}
                                      title="Select All"
                                    />
                                  </th>
                                </PermissionGate>
                                <th className="text-center min-w-100px">
                                  Company Logo
                                </th>
                                <th className="text-center min-w-100px">
                                  Company Name
                                </th>
                                <th className="text-center min-w-100px">
                                  Created At
                                </th>
                                <th className="text-center min-w-100px">
                                  Billing address
                                </th>
                                <th className="text-center min-w-100px">
                                  Invoiced At
                                </th>
                                <PermissionGate
                                  required={`edit_delivery_company_ring_priority`}
                                  fallback={<></>}
                                >
                                  <th className="text-center min-w-100px">
                                    Ring Priority
                                  </th>
                                </PermissionGate>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {data &&
                                data?.map((item, index) => {
                                  return (
                                    <tr key={index} className="text-center">
                                      <PermissionGate
                                        required={`edit_delivery_company_ring_priority`}
                                        fallback={<></>}
                                      >
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={selectedCompanies.includes(
                                              item._id
                                            )}
                                            onChange={() => {
                                              toggleSelectCompany(item._id);
                                            }}
                                          />
                                        </td>
                                      </PermissionGate>
                                      <td>
                                        {/*begin:: Avatar */}
                                        <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                          <Link
                                            to={`/delivary-companies/company-details/${item?._id}`}
                                          >
                                            <div className="symbol-label">
                                              <img
                                                src={
                                                  process.env
                                                    .REACT_APP_API_PUBLIC_URL +
                                                  item?.logo
                                                }
                                                alt={item?.name}
                                                className="w-100"
                                              />
                                            </div>
                                          </Link>
                                        </div>
                                        {/*end::Avatar*/}
                                      </td>
                                      <td>
                                        {/*begin::User details*/}
                                        <div className="d-flex">
                                          <Link
                                            to={`/delivary-companies/company-details/${item?._id}`}
                                            className="text-gray-800 text-hover-primary"
                                          >
                                            {item?.name}
                                          </Link>
                                        </div>
                                        {/*begin::User details*/}
                                      </td>
                                      <td>
                                        {moment(item?.createdAt)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("Do MMM, YYYY")}
                                      </td>
                                      <TruncatedTd length={50}>
                                        {item?.billingArea?.value +
                                          ", " +
                                          item?.billingBlock?.value +
                                          ", " +
                                          item?.billingStreet?.value}
                                      </TruncatedTd>
                                      <td>Not invoiced yet</td>
                                      <PermissionGate
                                        required={`edit_delivery_company_ring_priority`}
                                        fallback={<></>}
                                      >
                                        <td>
                                          <span
                                            className={
                                              item?.excludeFromRingPriority ===
                                                true
                                                ? "badge bg-danger text-light"
                                                : "badge bg-success text-light"
                                            }
                                          >
                                            {item?.excludeFromRingPriority ===
                                              true
                                              ? "Excluded"
                                              : "Included"}
                                          </span>
                                        </td>
                                      </PermissionGate>
                                      <td className="">
                                        <div className="btn-group">
                                          {/*begin::View*/}
                                          <PermissionGate
                                            required={`view_delivery_company_details`}
                                            fallback={<></>}
                                          >
                                            <Link
                                              to={`/delivary-companies/company-details/${item?._id}`}
                                              className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
                                              title="Show Details"
                                            >
                                              <i className="bi-duotone bi-eye fs-5"></i>
                                            </Link>
                                          </PermissionGate>
                                          {/*end::View*/}
                                          {/*begin::Edit*/}
                                          <PermissionGate
                                            required={`edit_delivery_company`}
                                            fallback={<></>}
                                          >
                                            <Link
                                              to={`/delivary-companies/edit-delivary-company/${item?._id}`}
                                              className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                              title="Edit"
                                            >
                                              <i className="bi-duotone bi-pen fs-5"></i>
                                            </Link>
                                          </PermissionGate>
                                          {/*end::Edit*/}
                                          {/*begin::Delete*/}
                                          <PermissionGate
                                            required={`delete_delivery_company`}
                                            fallback={<></>}
                                          >
                                            <button
                                              onClick={() => {
                                                openPopup(
                                                  "delete-company",
                                                  item
                                                );
                                              }}
                                              className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                              title="Delete Company"
                                            >
                                              <i className="bi-duotone bi-trash fs-5"></i>
                                            </button>
                                          </PermissionGate>
                                          {/*end::Delete*/}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {/*end::Table*/}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*begin::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/* start :: delete */}
          <div
            className={
              popup === "delete-company"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-danger text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">DELETE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setCompany({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={deleteDelivaryCompany}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: delete */}
          {/* start :: batch exclude ring priority */}
          <div
            className={
              popup === "batch-exclude"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    EXCLUDE FROM RING PRIORITY
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">
                    None of the {selectedCompanies.length} selected
                    compan{selectedCompanies.length === 1 ? "y's" : "ies'"}{" "}
                    drivers will get ring priority. Are You Sure ?
                  </p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={() => {
                      changeRingPriorityBatch(true);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: batch exclude ring priority */}
          {/* start :: batch include ring priority */}
          <div
            className={
              popup === "batch-include"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    INCLUDE IN RING PRIORITY
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">
                    The {selectedCompanies.length} selected compan
                    {selectedCompanies.length === 1 ? "y's" : "ies'"} drivers
                    will be eligible for ring priority again. Are You Sure ?
                  </p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={() => {
                      changeRingPriorityBatch(false);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: batch include ring priority */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default AllDelivaryCompanies;